import { Dispatch } from 'redux';
import { IReduxContext } from '../../store';
import { getVacanciesData } from '../vacancies';

import { getUserDataApi } from '../../../../app/api/get_user';
import { TReduxActions } from '../../../types/redux';
import { IUser } from '../../../types/user';
import { IStore } from '../../../types/store';

export interface IUserDataAction {
  type: 'user/DATA_SUCCESS';
  user: IUser;
}

export const getUserData = (nodeApiHost: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (dispatch: Dispatch<any>, getState: () => IStore, context: IReduxContext) => {
    getUserDataApi(context.makeRequest, nodeApiHost).then((user: IUser) => {
      dispatch({ type: 'user/DATA_SUCCESS', user });

      const { isAuthenticated, isProfi } = user;

      if (isAuthenticated && isProfi) {
        dispatch(getVacanciesData());
      }
    });
  };
};

const initialState: IUser = {
  isAuthenticated: false,
};

export const userReducer = (state = initialState, action: TReduxActions) => {
  switch (action.type) {
    case 'user/DATA_SUCCESS':
      return {
        ...action.user,
      };

    default:
      return state;
  }
};
